import "./trainers.css";
import { useEffect, useState } from "react";
import api from "../api";
import { Bounce, toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import maleProfile from "../Assets/Images/menProfile.jpg";
import femaleProfile from "../Assets/Images/femaleProfile.jpg";
import TrainerAnagrafica from "./TrainerAnagrafica";
import TrainerInterviste from "./TrainerInterviste";
import TrainerTitoliStudio from "./TrainerTitoliStudio";
import TrainerEsperienze from "./TrainerEsperienze";
import TrainerCandidature from "./TrainerCandidature";
import TrainerFeedback from "./TrainerFeedback";
import TrainerRicerca from "./TrainerRicerca";
import TrainerSimulazioni from "./TrainerSimulazioni";
import TrainerFollowUp from "./TrainerFollowUp";
import TrainerAccordo from "./TrainerAccordo";
import TrainerModuli from "./TrainerModuli";
import TrainerCurriculum from "./TrainerCurriculum";

// Tabs allowed for non-admin users (OPERATOR role)
const allowedTabsForOperator = [
  "anagrafica",
  "titoliStudio",
  "esperienze",
  "curriculum",
  "simulazioni",
  "accordi",
];

const EditTrainer = () => {
  const [originalTrainer, setOriginalTrainer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [anagrafica, setAnagrafica] = useState([]);
  const [feedback, setFeedback] = useState([]);
  const [interviste, setInterviste] = useState([]);
  const [titoliStudio, setTitoliStudio] = useState([]);
  const [candidature, setCandidature] = useState([]);
  const [moduliProtocollati, setModuliProtocollati] = useState([]);
  const [esperienzeLavorative, setEsperienzeLavorative] = useState([]);
  const [simulazioni, setSimulazioni] = useState([]);
  const [followup, setFollowup] = useState([]);
  const [accordoQuadro, setAccordoQuadro] = useState([]);
  const [ricercaAssociata, setRicercaAssociata] = useState([]);
  const [curriculum, setCurriculum] = useState([]);
  const [activeTab, setActiveTab] = useState("anagrafica");
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = localStorage.getItem("userRole");

  useEffect(() => {
    if (!userRole) {
      alert("Accedi per modificare il docente!");
      navigate("/login");
      localStorage.clear();
    } else {
      if (userRole === "ADMIN") {
        fetchAdminTrainer();
      } else if (userRole === "OPERATOR") {
        fetchOperatorTrainer();
      }
    }
  }, [navigate, userRole]);

  // Fetch trainer data
  const fetchAdminTrainer = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/trainers/${id}`);
      if (res.status === 200) {
        setOriginalTrainer(res.data);
        setAnagrafica(res.data.anagrafica);
        setInterviste(res.data.interviste || []);
        setTitoliStudio(res.data.titoliStudio || []);
        setCandidature(res.data.candidature || []);
        setEsperienzeLavorative(res.data.esperienzeLavorative || []);
        setSimulazioni(res.data.simulazioni || []);
        setFollowup(res.data.followup || []);
        setModuliProtocollati(res.data.moduliProtocollati || []);
        setFeedback(res.data.feedback || []);
        setAccordoQuadro(res.data.accordoQuadro || null);
        setRicercaAssociata(res.data.ricercaAssociata || null);
        setCurriculum(res.data.cv || null);
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchOperatorTrainer = () => {
    const targetTrainer = location.state?.trainer;
    if (targetTrainer) {
      setOriginalTrainer(targetTrainer);
      setAnagrafica(targetTrainer.anagrafica);
      setInterviste(targetTrainer.interviste || []);
      setTitoliStudio(targetTrainer.titoliStudio || []);
      setCandidature(targetTrainer.candidature || []);
      setEsperienzeLavorative(targetTrainer.esperienzeLavorative || []);
      setSimulazioni(targetTrainer.simulazioni || []);
      setFollowup(targetTrainer.followup || []);
      setModuliProtocollati(targetTrainer.moduliProtocollati || []);
      setFeedback(targetTrainer.feedback || []);
      setAccordoQuadro(targetTrainer.accordoQuadro || null);
      setRicercaAssociata(targetTrainer.ricercaAssociata || null);
      setCurriculum(targetTrainer.cv || null);
    } else {
      toast.error("Dati utente non trovati.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }

    setLoading(false);
  };

  const allTabButtons = [
    { key: "anagrafica", label: "Anagrafica" },
    { key: "interviste", label: "Interviste" },
    { key: "titoliStudio", label: "Titoli Studio" },
    { key: "esperienze", label: "Esperienze Lavorative" },
    { key: "candidature", label: "Candidature" },
    { key: "feedback", label: "Feedback" },
    { key: "moduli", label: "Moduli Protocollati" },
    { key: "curriculum", label: "Curriculum" },
    { key: "ricerca", label: "Ricerca Associata" },
    { key: "simulazioni", label: "Simulazioni" },
    { key: "followup", label: "Follow Up" },
    { key: "accordi", label: "Accordo Quadro" },
  ];

  const tabButtons =
    userRole === "ADMIN"
      ? allTabButtons
      : allTabButtons.filter((tab) =>
          allowedTabsForOperator.includes(tab.key)
        );

  useEffect(() => {
    if (location.state?.activeTab) {
      const requestedTab = location.state.activeTab;
      if (
        userRole === "ADMIN" ||
        allowedTabsForOperator.includes(requestedTab)
      ) {
        setActiveTab(requestedTab);
      } else {
        setActiveTab("anagrafica");
      }
      window.history.replaceState({}, document.title);
    }
  }, [location.state, userRole]);

  useEffect(() => {
    if (userRole && userRole !== "ADMIN") {
      if (!allowedTabsForOperator.includes(activeTab)) {
        setActiveTab("anagrafica");
      }
    }
  }, [userRole, activeTab]);

  const handleReturnBack = () => {
    if (userRole === "ADMIN") {
      navigate("/docenti");
    } else if (userRole === "OPERATOR") {
      navigate("/docenti/disponibile");
    }
  };

  return (
    <div className="content-page trainer">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">Modifica Docente</div>
      </div>

      {/* Profile Card */}
      <div className="trainer-profile-card">
        <div className="trainer-profile-img">
          <img
            src={anagrafica.sesso === "FEMMINA" ? femaleProfile : maleProfile}
            alt="Foto profilo"
          />
        </div>
        <div className="trainer-profile-info">
          <div className="trainer-profile-name">
            {anagrafica.nome} {anagrafica.cognome}
          </div>
          <div className="trainer-profile-email">{anagrafica.email}</div>
          <div className="trainer-profile-cf">
            CF: {anagrafica.codiceFiscale}
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="trainer-tabs">
        {tabButtons.map((tab) => (
          <button
            key={tab.key}
            className={`trainer-tab-btn${
              activeTab === tab.key ? " active" : ""
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="page-content trainer-container">
        <button onClick={handleReturnBack} className="return-btn">
          <i className="fa-solid fa-square-caret-left"></i>
        </button>
        {activeTab === "anagrafica" ? (
          <TrainerAnagrafica
            anagrafica={anagrafica}
            operatorView={userRole === "OPERATOR"}
          />
        ) : activeTab === "interviste" ? (
          <TrainerInterviste
            interviste={interviste}
            operatorView={userRole === "OPERATOR"}
          />
        ) : activeTab === "titoliStudio" ? (
          <TrainerTitoliStudio
            titoliStudio={titoliStudio}
            codiceFiscale={anagrafica.codiceFiscale}
            operatorView={userRole === "OPERATOR"}
          />
        ) : activeTab === "esperienze" ? (
          <TrainerEsperienze
            esperienza={esperienzeLavorative}
            operatorView={userRole === "OPERATOR"}
          />
        ) : activeTab === "candidature" ? (
          <TrainerCandidature candidature={candidature} />
        ) : activeTab === "feedback" ? (
          <TrainerFeedback feedback={feedback} />
        ) : activeTab === "moduli" ? (
          <TrainerModuli
            moduliProtocollati={moduliProtocollati}
            operatorView={userRole === "OPERATOR"}
          />
        ) : activeTab === "curriculum" ? (
          <TrainerCurriculum
            curriculum={curriculum}
            cvUploaded={originalTrainer?.cvUploaded ?? Boolean(originalTrainer?.cv ?? (Array.isArray(curriculum) ? curriculum.length > 0 : curriculum))}
            codiceFiscale={anagrafica?.codiceFiscale}
          />
        ) : activeTab === "ricerca" ? (
          <TrainerRicerca ricercaAssociata={ricercaAssociata} />
        ) : activeTab === "simulazioni" ? (
          <TrainerSimulazioni simulazioni={simulazioni} />
        ) : activeTab === "followup" ? (
          <TrainerFollowUp followup={followup} />
        ) : activeTab === "accordi" ? (
          <TrainerAccordo
            accordoQuadro={accordoQuadro}
            setActiveTab={setActiveTab}
          />
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
};

export default EditTrainer;
